"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useV1Signup = void 0;
const api_1 = require("core/api");
const React = __importStar(require("react"));
const useExperiments_1 = require("src/hooks/useExperiments");
const useNavigation_1 = require("src/hooks/useNavigation");
const useRequest_1 = require("src/hooks/useRequest");
const validation_signup_1 = require("utils/validation-signup");
const defaultNewUser = {
    email: '',
    firstName: '',
    lastName: '',
    password: '',
    birthdate: '',
    receivesNewsletter: true,
    termsAndConditionsAccepted: false,
};
const useV1Signup = () => {
    const { navigate } = (0, useNavigation_1.useNavigation)();
    const experiments = (0, useExperiments_1.useExperiments)();
    const ageGating = experiments[useExperiments_1.EXPERIMENT_IDS.AGE_GATING];
    const birthdateRequired = ageGating ? ageGating?.isEnabled && ageGating?.hasAccess : undefined;
    const urlParams = new URLSearchParams(window.location.search);
    const email = urlParams?.get('email')?.replace(' ', '+') || ''; // URLSearchParams converts + to space, so we need to convert it back
    const [newUser, setNewUser] = React.useState({
        ...defaultNewUser,
        email,
    });
    const [errors, setErrors] = React.useState({});
    const { isProcessing, makeRequest } = (0, useRequest_1.useRequest)();
    const submitUser = async () => {
        // validate fields
        const er = (0, validation_signup_1.validateSignupFields)({ ...newUser }, [
            ...['firstName', 'lastName', 'email', 'password', 'termsAndConditionsAccepted'],
            ...(birthdateRequired ? ['birthdate'] : []),
        ]);
        if (Object.keys(er).length > 0) {
            setErrors(er);
            er?.termsViolated &&
                setNewUser({
                    ...defaultNewUser,
                    email: newUser.email,
                    // TODO remove this hack once snapi-ui component is updated
                    birthdate: '---', // temp hack clear birthdate
                });
            return;
        }
        const userResponse = await makeRequest(() => api_1.NewUserService.createUser({
            email: newUser.email,
            firstName: newUser.firstName,
            lastName: newUser.lastName,
            password: newUser.password,
            birthdate: newUser.birthdate,
            receivesNewsletter: !!newUser.receivesNewsletter,
            termsAndConditionsAccepted: !!newUser.termsAndConditionsAccepted,
        }), undefined, {
            customErrorHandler: (callError, responseError) => {
                if (callError?.message?.toLowerCase() === 'network error') {
                    if (responseError?.error) {
                        responseError.error.isNetworkError = true;
                        delete responseError.error?.detail;
                    }
                }
            },
        }); // Sets sso cookie
        if (userResponse.ok) {
            navigate.v1RoleSelect({ isSignup: true });
        }
        if (userResponse?.error?.title?.toLowerCase().includes('email')) {
            setErrors((prev) => ({ ...prev, email: userResponse.error?.detail }));
        }
        if (userResponse?.error?.title?.toLowerCase().includes('password')) {
            setErrors((prev) => ({ ...prev, password: userResponse.error?.detail }));
        }
        if (userResponse?.error?.isNetworkError) {
            setErrors((prev) => ({ ...prev, isNetworkError: true }));
        }
        if (userResponse?.error?.status === 400 && userResponse.error.extensions?.redirectPath) {
            window.location.href = userResponse.error.extensions.redirectPath;
            return;
        }
    };
    return {
        newUser,
        submitUser,
        setUser: (key, value) => {
            const er = { ...errors };
            delete er[key];
            setErrors(er);
            setNewUser((prev) => ({ ...prev, [key]: value }));
        },
        errors,
        isProcessing,
        birthdateRequired,
    };
};
exports.useV1Signup = useV1Signup;
